import { SITE_ROUTES } from "@/src/common/constants/site-routes";
import type { LegalDocumentKey } from "./legal-content";

export const LEGAL_PAGES: ReadonlyArray<{ key: LegalDocumentKey; to: string }> = [
	{ key: "privacy", to: SITE_ROUTES.PRIVACY },
	{ key: "terms", to: SITE_ROUTES.TERMS },
	{ key: "legal_notices", to: SITE_ROUTES.LEGAL_NOTICES },
];
